import React from 'react';
import clsx from 'clsx';
import { Avatar as MuiAvatar, colors, makeStyles } from '@material-ui/core';

import getInitials from '../utils/getInitials';


const useStyles = makeStyles((theme) => ({
  avatar: {
    marginRight: theme.spacing(1),
    fontSize: 14,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.common.white,
  }
}));

const getColor = (firstName: any, lastName: any) => {
  const name = `${firstName} ${lastName}`;
  const colorsList = [
    colors.red['700'],
    colors.purple['700'],
    colors.deepPurple['700'],
    colors.indigo['700'],
    colors.blue['700'],
    colors.teal['700'],
    colors.green['700'],
    colors.orange['700'],
    colors.deepOrange['700'],
  ];
  const nameValue = name.split('').reduce((acc, el) => el.charCodeAt(0), 0) % colorsList.length;

  return colorsList[nameValue];
};

const getInitialsForProfile = (firstName: any, lastName: any) => (
  getInitials(`${firstName} ${lastName}`)
);

const Avatar = ({
  src,
  firstName,
  lastName,
  email,
  className,
  size = 'small',
  ...rest
}: any) => {
  const classes = useStyles();
  /*
  Uses the src image for the avatar if present, otherwise depends on a profile to be passed in so initials
  and a color can be generated for the user
   */
  if (src) {
    return (
      <MuiAvatar
        className={clsx(classes.avatar, className)}
        size={size}
        src={src}
        {...rest}
      />
    );
  }
  if (firstName && lastName) {
    return (
      <MuiAvatar
        className={clsx(classes.avatar, className)}
        size={size}
        style={{ backgroundColor: getColor(firstName, lastName) }}
        {...rest}
      >
        {getInitialsForProfile(firstName, lastName)}
      </MuiAvatar>
    );
  }

  if (email) {
    return (
      <MuiAvatar
        className={clsx(classes.avatar, className)}
        size={size}
        style={{ backgroundColor: colors.grey['500'] }}
        {...rest}
      >
        {getInitials(email)}
      </MuiAvatar>
    );
  }

  return null;
};

export default Avatar;
